import {Construtor} from './construtor';

export class UsuarioParametroGrafico implements Construtor<UsuarioParametroGrafico> {
  public idUsuarioParametroGrafico: number;
  public idParametroGrafico: number;
  public idUsuario: number;
  public alterado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof UsuarioParametroGrafico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(usuario: UsuarioParametroGrafico): void {
    this.idUsuarioParametroGrafico = usuario.idUsuarioParametroGrafico;
    this.idParametroGrafico = usuario.idParametroGrafico;
    this.idUsuario = usuario.idUsuario;
  }

  parseFromJson(usuario: any): void {
    this.idUsuarioParametroGrafico = usuario.idUsuarioParametroGrafico;
    this.idParametroGrafico = usuario.idParametroGrafico;
    this.idUsuario = usuario.idTipoPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): UsuarioParametroGrafico {
    return new UsuarioParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/usuario-parametro-grafico.ts